import { gql } from '@apollo/client';

export const UserFields = gql`
  fragment UserFields on User {
    id
    role
    subtype
    lastName
    firstName
    slug
    email
    phoneNumber
    isOnboarded
    isEmailSet
    onboardingSteps
    cartSize
    status
    hasPassword
    phoneOptIn
    hashtags {
      id
      name
    }
    avatarUrl
    avatarKey
    storeDetails {
      id
      athleticLevel
      hasActedOnAutoGeneratedMerch
      storeName
      storeTitle
      bio
      careerStatus
      avatarURL
      socialMediaLink
      description
      coverURL
      facebookLink
      twitterLink
      instagramLink
      tiktokLink
      youtubeLink
      facebookFollowing
      twitterFollowing
      tiktokFollowing
      instagramFollowing
      youtubeFollowing
      birthDate
      gender
      hometown
      hometownState
      hometownCountry
      hometownLongitude
      hometownLatitude
      state
      country
      city
      latitude
      longitude
      signUpFlow
      gymRole
    }
    sports {
      id
      name
    }
    brandDealSettings {
      id
      contactEmail
      minFlatPrice
    }
  }
`;
